import { fetchProfileShortInfo, fetchProfile, updateProfile } from '../../../services/api/profile';
import {
    validate,
    isRequired,
    isNumber,
    isKpp,
    isBik,
    isPaymentAccount,
    isCorrespondentAccount,
    isMinLength,
    isEmail,
    isPhone,
    isCyrillicFio,
    isCyrillic,
    isInn,
    isIndividualInn,
    isOgrn,
    isIndividualOgrn,
    isLengthy,
} from '../../../services/validator';

function isMinNameLength(val) {
    return isMinLength(val, 2);
}

export const profile = {
    namespaced: true,
    state: {
        isFetched: false,
        profile: {},
    },
    mutations: {
        save(state, data) {
            state.profile = { ...state.profile, ...data };
        },
        update(state, data) {
            state.profile = {
                ...data,
                id: state.profile.id,
                orgTypeId: state.profile.orgTypeId,
                orgName: state.profile.orgName,
                isIdentified: data.isIdentified === "true",
                isIndividual: data.isIndividual === "true",
            };
        },
        fetched(state) {
            state.isFetched = true;
        },
        resetState(state) {
            state.isFetched = false;
            state.profile = {};
        }
    },
    actions: {
        resetState({ commit }) {
            commit('resetState');
        },
        fetchProfileShortInfo({ commit, dispatch }) {
            return fetchProfileShortInfo()
                .then((res) => {
                    commit('save', res.data);

                    return res;
                })
                .catch((res) => {
                    dispatch('error', res, { root: true });

                    return Promise.reject(res);
                });
        },
        fetchProfile({ commit, dispatch }) {
            return fetchProfile()
                .then((res) => {
                    commit('save', res.data);
                    dispatch('fetched');

                    return res;
                })
                .catch((res) => {
                    dispatch('error', res, { root: true });

                    return Promise.reject(res);
                });
        },
        updateProfile({ commit, dispatch }, values) {
            return updateProfile(values)
                .then((res) => {
                    commit('update', values);
                    return res;
                })
                .catch((res) => {
                    dispatch('error', res, { root: true });
                    return Promise.reject(res);
                });
        },
        fetched({ commit }) {
            commit('fetched');
        }
    },
    getters: {
        profile({ profile }, { companyOrgType }) {
            return {
                ...profile,
                orgType: {
                    id: profile.orgTypeId,
                    name: companyOrgType
                }
            };
        },
        companyId({ profile }) {
            return profile.id || 0;
        },
        companyFullName({ profile }) {
            return `«${profile.cabinet}»`;
        },
        companyOrgType({ profile }, getters, rootState, rootGetters) {
            const orgTypes = rootGetters['orgTypes/orgTypesObject'];

            return orgTypes[profile.orgTypeId] || '';
        },
        refinanceIntegrated({ profile }) {
            return Boolean(profile.refinanceIntegrated);
        },
        filledErrors({ profile }) {
            const rules = {
                // Компания
                inn: [
                    isRequired,
                    (val) => profile.activityType == 1
                        ? isInn(val)
                        : isIndividualInn(val),
                ],
                ogrn: [
                    isRequired,
                    (val) => profile.activityType == 1
                        ? isOgrn(val)
                        : isIndividualOgrn(val)
                ],
                bik: [
                    isRequired,
                    isBik,
                ],
                paymentAccount: [
                    isRequired,
                    isPaymentAccount,
                ],
                correspondentAccount: [
                    isRequired,
                    isCorrespondentAccount,
                ],
                bankName: [isRequired],
                // Контактное лицо
                contactEmail: [
                    isRequired,
                    isEmail,
                ],
                contactFio: [
                    isRequired,
                    isCyrillicFio,
                    (val) => isMinLength(val, 4),
                ],
                contactPhone: [
                    isRequired,
                    isPhone,
                ],
                addressUr: [isRequired],
                addressPost: [isRequired],
            };

            if (profile.activityType == 1) {
                // Данные подписанта
                rules.orgName = [isRequired];
                rules.post = [isRequired];
                rules.basisPost = [isRequired];
                rules.lastName = [isCyrillic, isMinNameLength, isRequired];
                rules.firstName = [isCyrillic, isMinNameLength, isRequired];
                rules.middleName = [isCyrillic, isMinNameLength, isRequired];                
                rules.kpp = [isRequired, isKpp];
            }

            return validate(profile, rules);
        },
        isFilled(state, { filledErrors }) {
            // console.log(filledErrors);
            // console.log(Object.keys(filledErrors).length);
            return !filledErrors || !Object.keys(filledErrors).length;
        },
        isIdentified({ profile }, getters, rootState, rootGetters) {
            return profile.isIdentified;
        },
        balance({ profile }, getters, rootState, rootGetters) {
            return profile.balance;
        }
    }
};



// WEBPACK FOOTER //
// ./src/modules/home/profile/store.js